var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeastGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42102 7.22228L7.63155 9.55561L15 1.77783",
    stroke: "#3CA48E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2632 8V13.4444C14.2632 13.857 14.1079 14.2527 13.8315 14.5444C13.5552 14.8361 13.1803 15 12.7895 15H2.47368C2.08284 15 1.708 14.8361 1.43163 14.5444C1.15526 14.2527 1 13.857 1 13.4444V2.55556C1 2.143 1.15526 1.74733 1.43163 1.45561C1.708 1.16389 2.08284 1 2.47368 1H10.5789",
    stroke: "#3CA48E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeastGreen);
export default __webpack_public_path__ + "static/media/leastGreen.9d6c0eb0.svg";
export { ForwardRef as ReactComponent };